import * as React from "react";
import {useState, useRef} from "react";
import {uploadImage} from "../service/ImageService";
import {Alert, ProgressBar} from "react-bootstrap";
import {Button} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";


export default function ImageUpload({images, setImages, prepareUpload, accept = "image/*, video/*, application/pdf", onUploadingChange, onUploadError}) {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadPercentage, setUploadPercentage] = useState(0);
    const [fileCount, setFileCount] = useState(0);
    const fileInputRef = useRef(null);
    const imagesRef = useRef(images);
    imagesRef.current = images;

    const handleUpload = async (newValue) => {
        let pendingImages = [];
        const progressArray = new Array(newValue.length).fill(0);

        setIsUploading(true);
        onUploadingChange?.(true);
        setFileCount(newValue.length);

        const updateTotalProgress = () => {
            const totalProgress = progressArray.reduce((acc, curr) => acc + curr, 0) / newValue.length;
            const totalProgressRounded = Number(totalProgress.toFixed(2));
            setUploadPercentage(totalProgressRounded);
        };

        try {
            const results = await Promise.allSettled(newValue.map(async (file, index) => {
                const fileType = file?.type?.split("/")[1]?.toLowerCase() || "unknown";
                const fileName = file?.name || "unknown";
                const response = await prepareUpload(fileName, fileType);
                if (response.status !== 200) throw new Error("Unable to prepare image upload");

                const data = await response.json();
                await uploadImage(data.upload_url, file, (percentage) => {
                    progressArray[index] = percentage;
                    updateTotalProgress();
                });
                pendingImages.push(data);
            }));
            if (pendingImages.length) setImages([...imagesRef.current, ...pendingImages]);
            const failures = results.filter(result => result.status === "rejected");
            if (failures.length) {
                const message = `${failures.length} photo upload(s) failed. Please retry.`;
                onUploadError?.(message);
                console.error(message);
            }
        } finally {
            setFileCount(0);
            setIsUploading(false);
            onUploadingChange?.(false);
            setUploadPercentage(0);
        }
    };


    return (
        <>
            <input
                ref={fileInputRef}
                type="file"
                accept={accept}
                multiple
                hidden
                onChange={(e) => {
                    const fileList = Array.from(e.target.files);
                    if (fileList.length > 0) handleUpload(fileList);
                    e.target.value = "";
                }}
            />
            <Button
                variant="outlined"
                fullWidth
                size="small"
                disabled={isUploading}
                startIcon={<AttachFileIcon />}
                onClick={() => fileInputRef.current?.click()}
                sx={{mt: 1, justifyContent: "flex-start", textTransform: "none", color: "text.secondary"}}
            >
                {fileCount > 0 ? `${fileCount} file(s) selected` : "Click to Insert your images"}
            </Button>
            {isUploading &&
                <Alert key={"primary"} variant={"primary"}>
                    <ProgressBar animated now={uploadPercentage} label={`${uploadPercentage}%`}/>
                    Uploading...Please wait
                </Alert>
            }
        </>
    )
}
